import styled from "styled-components";

export const GreyOverlayContainer = styled.div`
    z-index: 103;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: fixed;
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
    vertical-align: middle;
`;


// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/GreyOverlayStyle.js